// extracted by mini-css-extract-plugin
module.exports = {"StudentLayoutPage":"StudentLayoutPage_StudentLayoutPage__2NOqg"};